<template>
    <div>
        <vue-perfect-scrollbar style="height: 408px" :settings="settings">
            <v-data-table :headers="headers" :items="dashboard_invoices || []" :no-data-text="$t('lang.loading')" hide-actions
                ><template slot="items" slot-scope="props">
                    <tr class="clickable" @click="$router.push({ name: 'invoice', params: { id: props.item.invoice_id } })">
                        <td>{{ props.item.invoice_id }}</td>
                        <td>{{ props.item.company }}</td>
                        <td>{{ props.item.date_due }}</td>
                        <td>{{ props.item.invoice_total }}</td>
                        <td>{{ props.item.status.option }}</td>
                    </tr>
                </template></v-data-table
            >
        </vue-perfect-scrollbar>
    </div>
</template>
<script>
import api from "Api";
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            loader: true,
            settings: {
                maxScrollbarLength: 160,
            },
            headers: [
                {
                    text: this.$t("lang.invoice_number_short"),
                    value: "invoice_id",
                    format: (v) => {
                        return v;
                    },
                    align: "center",
                    text_center: true,
                    sortable: false,
                },
                {
                    text: this.$t("lang.company_id"),
                    value: "company",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.date_due"),
                    value: "date_due",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.total"),
                    value: "invoice_total",
                    format: (v) => {
                        return v;
                    },
                    sortable: false,
                },
                {
                    text: this.$t("lang.status"),
                    value: "status.option",
                    format: (v) => {
                        return v;
                    },
                    chip_color: "status.class",
                    align: "center",
                    sortable: false,
                },
            ],
            qc_inspections: [],
        };
    },
    computed: {
        ...mapState({
            dashboard_invoices: (state) => state.invoices.dashboard_invoices,
        }),
    },
    mounted() {
        this.getInvoices();
    },
    methods: {
        async getInvoices(refresh = false) {
            if (refresh) {
                this.$store.commit("commitInvoice", {
                    property: "dashboard_invoices",
                    with: null,
                });
            }

            this.$store.dispatch("fetchInvoice", {
                url: "invoices",
                method: "get",
                stateProperty: "dashboard_invoices",
                dataProperty: "invoices",
                commit: true,
                body: {
                    invoice_status: ["draft", "sent", "approved"],
                },
            });
        },
    },
};
</script>
